<template>
    <div id="project" class="project_home">
        <div class="project_content">
            <h2 class="project-title">苏州高新区2026年第二次面向社会认定中小学教师资格  现场确认预约</h2>
            <div style="padding:0 10px">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" v-for="item in projectList" :key="item.id">
                    <div class="project_item">
                        <span class="project_date">日期：{{item.confirm_date}}</span>
                        <span class="project_time">{{item.confirm_time}}</span>
                        <br>
                        <span class="project_number">余票：{{item.remain_number}}票</span>
                        <el-button type="primary" round style="float:right" @click="preengageClick(item.id)" :disabled="item.remain_number == 0?true:false">预约</el-button>
                    </div>
                </el-col>
            </el-row>
            </div>
            <el-divider></el-divider>
            <div style="text-align:center;color:#e5dddd;margin-bottom:10px"><i class="el-icon-warning-outline"></i> 没有更多数据</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            projectList:[],
            loading:null,
        }
    },
    mounted(){
        switch(this.$global.status){
            case -1:
                this.$router.push('/schoolHome/login')
                break;
            case 2:
                this.$router.push('/schoolHome/confirmRecord')
                break;
        }
        this.getInfo()
    },
    methods:{
        getInfo(){
            this.$request.getNDNF(this.$url.type.base,this.$url.school.confirmList,success=>{
                this.projectList = [];
                this.projectList = success.data
            })
        },
        preengageClick(id){
            var projectEle = document.getElementById('project')          
            let self = this
            this.loading = this.$loading({
                target:projectEle,
                lock: true,
                text: '预约中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$request.postForm(this.$url.type.base,this.$url.school.confirmKill,{id:id},success=>{   
                this.loading.close()
                this.$router.push('/schoolHome/confirmRecord')
                this.$message.success('预约成功')
            },failure=>{
                this.loading.close()
                this.$message.warning(failure.msg)
            })
        }
    }
}
</script>
<style scoped>
    .project_home{
        position: absolute;
        left:0;
        right:0;
        top:0;
        bottom:70px;
        padding-bottom:10px;
        background-color:#f1f1f1;
        background-image: linear-gradient(to top, #6a85b6 0%, #bac8e0 100%);
        overflow-y: auto;
    }

    .project-title{
        text-align:center;
        padding:10px;
        color:#454545;
    }

    .project_content{
        width:1200px;
        margin:0 auto;       
    }

    .project_item{ 
        margin-top:10px;
        height:80px;
        background-image: linear-gradient(120deg, #8fd3f4 0%, #84fab0 100%);
        border-radius: 5px;
        line-height: 40px;
        padding:10px;
    }

    .project_date{
        font-size:18px;
        font-weight: bold;
        color:#12731e;
    }

    .project_time{
        font-size:18px;
        color:#12731e;
        font-weight: bold;
        margin-left:10px;
    }

    .project_number{
        font-size:16px;
        color:#1f0d3c;
    }

    @media (max-width:768px){
        .project_content{
            width:100%;
        }
    }
</style>